export function applyDialogUserConfig(store, data) {
  const current = store.state.dialogUserConfig || {};
  const notifs = (Array.isArray(data?.notifs) ? data.notifs : (current.notifs || []))
    .map(v => ({id: v.id, name: v.name}));
  const ids = notifs.map(v => v.id);
  let notif = current.notif || null;
  if (data && Object.prototype.hasOwnProperty.call(data, 'notif')) {
    notif = (ids.length === 0 || ids.includes(data.notif))
      ? data.notif
      : (current.notif || ids[0] || null);
  }

  store.commit('setDialogUserConfig', {
    loaded: true,
    notif,
    notifs,
    catInternal: data && Object.prototype.hasOwnProperty.call(data, 'catInternal') ? !!data.catInternal : current.catInternal !== false,
    catQueue: data && Object.prototype.hasOwnProperty.call(data, 'catQueue') ? !!data.catQueue : current.catQueue !== false,
    catProcess: data && Object.prototype.hasOwnProperty.call(data, 'catProcess') ? !!data.catProcess : current.catProcess !== false,
    catClosed: data && Object.prototype.hasOwnProperty.call(data, 'catClosed') ? !!data.catClosed : current.catClosed !== false,
  });
}

export function saveDialogUserConfig(store, axios, patch) {
  applyDialogUserConfig(store, patch);
  return axios.put('/napi/dialog/user/config/', patch).catch(() => {
    return axios.get('/napi/dialog/user/config/').then(r => applyDialogUserConfig(store, r.data));
  });
}

export function saveDialogNotif(store, axios, notif) {
  return saveDialogUserConfig(store, axios, {notif});
}

export function isDialogCatVisible(cat, config) {
  if (cat === 'internal')
    return config?.catInternal !== false;
  if (cat === 'queue')
    return config?.catQueue !== false;
  if (cat === 'process')
    return config?.catProcess !== false;
  if (cat === 'closed')
    return config?.catClosed !== false;
  return true;
}

export function hiddenDialogCats(config) {
  const hidden = [];
  if (config?.catInternal === false)
    hidden.push('internal');
  if (config?.catQueue === false)
    hidden.push('queue');
  if (config?.catProcess === false)
    hidden.push('process');
  if (config?.catClosed === false)
    hidden.push('closed');
  return hidden;
}

export function shouldPlayDialogRing(data, userId, config) {
  const notif = typeof config === 'string' ? config : config?.notif;
  if (notif === 'off')
    return false;
  if (config && typeof config !== 'string' && config.loaded !== true)
    return false;
  if (!isDialogCatVisible(data.cat, typeof config === 'string' ? null : config))
    return false;

  const mes = data.dialogMesLast;
  if (data.muted)
    return false;
  if (mes?.type !== 'message')
    return false;
  if (mes?.dialogUser?.user?.id === userId)
    return false;

  const inChat = data.dialogUsers?.some(v => v.user?.id === userId);
  if (inChat)
    return true;
  if (notif !== 'all')
    return false;
  if (data.cat !== 'queue')
    return false;

  return true;
}

export function emptyDialogUserConfig() {
  return {
    loaded: false,
    notif: null,
    notifs: [],
    catInternal: true,
    catQueue: true,
    catProcess: true,
    catClosed: true,
  };
}
